/* eslint-disable no-console */
import { ModalBox, StyledButton, StyledCheckbox } from './styles';

import { setCookie, getCookie } from 'services/utils/cookies';

import Icon from '@icons';
import Modal from '@material-ui/core/Modal';
/**
 * PropTypes é um mecanismo utilizado para garantir que os 
 * componentes usem o tipo de dados correto e passem os dados corretos
 */
import PropTypes from 'prop-types';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { useState } from 'react';
/**
 * ReactDOM é um pacote que fornece métodos específicos do DOM que podem
 * ser usados no nível superior do seu aplicativo e como uma saída de 
 * emergencia para sair do modelo React.
 */
import ReactDOM from 'react-dom';

/**
 * ReactDOM.render() função recebe dois argumentos, codigo HTML e um 
 * elemento html, a função tem como objetivo exibir o codigo HTML espe-
 * cificado dentro do elemento HTML especificado.
 */
const onClose = () => {
  ReactDOM.render(null, document.getElementById('alert'));
};

/**
 * Alert é um substituto do window.alert() nativo do javascript com
 * a diferença de que esse está estilizado em um modal com a identidade
 * visual do projeto. Apenas um alert por vez pode ser disparado e ele
 * pode ter um callback ao confirmar.
 * Também é possível disponibilizar a opção 'Não mostre novamente' para o 
 * usuário com um timer de reexibição predefinido.
 */
export const AlertConfirm = ({ title, message, callback, buttonText, configInformationalMessage, titleColor, buttonStyle }) => {
  const [dontShowInformationMessage, setDontShowInformationMessage] = useState(false);

  const closeAndCallback = () => {
    if (callback && typeof callback === 'function') {
      callback();
    }
    onClose();
  };

  const confirmAlert = () => {
    if (dontShowInformationMessage) {
      setCookie(
        configInformationalMessage.aliasModule,
        configInformationalMessage.toolId,
        configInformationalMessage.aliasIdentifierCookie,
        true,
        configInformationalMessage.expireDays,
      );
    }
    closeAndCallback();
  };

  /**
   * Estrutura do componente Alert modal com
   * identidade visual do projeto
   */
  return !getCookie(
    configInformationalMessage?.aliasModule,
    configInformationalMessage?.toolId,
    configInformationalMessage?.aliasIdentifierCookie) && 
    (
      <Modal style={{ zIndex: 1700 }} open={true} onClose={closeAndCallback}>
        <ModalBox optionDontShowAlertAgain={configInformationalMessage?.optionDontShowAlertAgain}>
            <button onClick={closeAndCallback} className="close">
                <Icon i="all-close" />
            </button>
            <header>
            <h2 style={{ color: titleColor }}>{title || 'GEOBAHIA informa:'}</h2>
            </header>
            <body>
                <div className="content">{message && <p>{message}</p>}</div>
            </body>
            <footer>
                {configInformationalMessage?.optionDontShowAlertAgain && (
                    <div className="dont-show-again">
                        <StyledCheckbox                
                        checked={dontShowInformationMessage}
                        color="primary"
                        onClick={(e) => {
                            e.stopPropagation();                    
                            setDontShowInformationMessage(!dontShowInformationMessage);
                        }}
                        size="small"
                        />
                        Não exibir essa mensagem novamente.
                    </div>
                )}
                <div className='button'>
                <StyledButton  
                style={buttonStyle}          
                variant="contained"
                color="primary"
                onClick={confirmAlert}
                >
                {buttonText || 'OK'}
                </StyledButton>
                </div>
            </footer>
        </ModalBox>
      </Modal>
    );
};

AlertConfirm.propTypes = {
  /** Titulo do Alerta */
  title: PropTypes.string,
  /** Mensagem do Alerta */
  message: PropTypes.string.isRequired,
  /** Função de callback */
  callback: PropTypes.func,
  /** Texto do botão do Alerta */
  buttonText: PropTypes.string,
  /** Opção "Não mostrar novamente"*/
  configInformationalMessage: PropTypes.object,
};

export default AlertConfirm;
